import { useRecordContext } from 'react-admin';

const ClientNameField = () => {
  const record = useRecordContext();
  return record ? <span>{record.first_name} {record.last_name}</span> : null;
};

export default ClientNameField;